'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export interface Router {
  /**
   * he path as shown in the browser including the search params and respecting the trailingSlash configuration. basePath and locale are not included.
   */
  asPath: string;
  /**
   * The path for current route file that comes after /pages. Therefore, basePath, locale and trailing slash (trailingSlash: true) are not included.
   */
  pathname: string;
}

export const useRouting = (): Router => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [asPath, setAsPath] = useState( '' );

  useEffect( () => {
    setAsPath( `${pathname}?${searchParams.toString()}` );
  }, [pathname, searchParams] );

  return { asPath, pathname };
};
